import { createSlice } from "@reduxjs/toolkit";
import { toGetAboutUs } from "../actions/aboutUs.actions";

const initialState = {
  aboutus: {
    list: [],
    status: "idle",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const aboutUsSlice = createSlice({
  name: "aboutUs",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetAboutUs.pending, (state) => {
      state.aboutus = {
        list: state.aboutus?.list ?? [],
        status: "loading",
      };
    });
    builder.addCase(toGetAboutUs.fulfilled, (state, action) => {
      state.aboutus = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetAboutUs.rejected, (state, action) => {
      state.aboutus = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default aboutUsSlice.reducer;
